import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Target, Eye, MessageCircle } from 'lucide-react';

const AboutSection = () => {
  const { language, isRTL } = useLanguage();

  const content = {
    ar: {
      aboutTitle: 'من نحن',
      aboutText: 'SyrVerse شركة تقنية ناشئة تعمل على تطوير حلول ومنصات رقمية ذكية تهدف إلى تسهيل الحياة اليومية، من خلال توظيف التقنية لخلق تجارب استخدام بسيطة، عملية، وقابلة للتطوّر، تنطلق من فهم حقيقي لاحتياجات المجتمع.',
      visionTitle: 'رؤيتنا',
      visionText: 'أن تكون SyrVerse صلة وصل رقمية فعّالة بين أفراد المجتمع، عبر إنشاء منصات حديثة تُمكّن من تبادل الخدمات بسلاسة بين مقدّمي الخدمات ومتلقيها، ضمن بيئة موثوقة تعزّز التعاون وتفتح آفاقًا جديدة للتكامل الرقمي.',
      missionTitle: 'رسالتنا',
      missionText: 'تطوير منتجات رقمية مبتكرة تُسهم في تنظيم وتسهيل الوصول إلى الخدمات، وتدعم بناء منظومة رقمية متكاملة تعتمد على الجودة، الوضوح، ووضع الإنسان في قلب كل تجربة.'
    },
    en: {
      aboutTitle: 'About Us',
      aboutText: 'SyrVerse is a tech startup developing smart digital solutions and platforms aimed at simplifying daily life, by leveraging technology to create simple, practical, and scalable user experiences, based on a genuine understanding of community needs.',
      visionTitle: 'Our Vision',
      visionText: 'For SyrVerse to be an effective digital link between community members, through creating modern platforms that enable seamless service exchange between service providers and recipients, within a trusted environment that promotes collaboration and opens new horizons for digital integration.',
      missionTitle: 'Our Mission',
      missionText: 'Developing innovative digital products that contribute to organizing and facilitating access to services, and supporting the building of an integrated digital ecosystem based on quality, clarity, and putting people at the heart of every experience.'
    }
  };

  const t = content[language];

  const sections = [
    {
      icon: <Target size={40} />,
      title: t.aboutTitle,
      text: t.aboutText
    },
    {
      icon: <Eye size={40} />,
      title: t.visionTitle,
      text: t.visionText
    },
    {
      icon: <MessageCircle size={40} />,
      title: t.missionTitle,
      text: t.missionText
    }
  ];

  return (
    <section 
      id="about" 
      className="relative py-32 bg-black"
      dir={isRTL ? 'rtl' : 'ltr'}
    >
      {/* Subtle background effect */}
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-white/[0.02] to-transparent"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-3 gap-12">
          {sections.map((section, index) => (
            <div 
              key={index}
              className="group relative bg-white/[0.03] border border-white/10 p-8 hover:bg-white/[0.06] transition-all duration-500"
            >
              {/* Icon */}
              <div className="mb-6 text-white/80 group-hover:text-white transition-colors duration-300">
                {section.icon}
              </div>

              {/* Title */}
              <h3 className="text-2xl md:text-3xl font-bold text-white mb-4">
                {section.title}
              </h3>

              {/* Text */}
              <p className="text-white/70 leading-relaxed text-lg">
                {section.text}
              </p>

              {/* Decorative corner */}
              <div className="absolute top-0 left-0 w-8 h-8 border-t-2 border-l-2 border-white/20 group-hover:border-white/40 transition-colors duration-300"></div>
              <div className="absolute bottom-0 right-0 w-8 h-8 border-b-2 border-r-2 border-white/20 group-hover:border-white/40 transition-colors duration-300"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
